<div class="content-container batch-table" style="padding-bottom: 30px">
  <div class="row button-container mb-2 justify-content-end g-2 batch-table__toolbar">
    <div class="col-2">
      <input type="search" class="form-control" placeholder="Search by Client or Project Name" [value]="searchValue()"
        (keyup)="search($event.target.value)" (search)="search($event.target.value)" />
    </div>
    <div class="col-auto">
      <div class="year-select-wrap">
        <select class="form-select year-select" [ngModel]="selectedYear()" (ngModelChange)="onYearChange($event)">
          <option [ngValue]="null">All Years</option>
          <option *ngFor="let y of years" [ngValue]="y">
            {{ y }}
          </option>
        </select>

        <button *ngIf="selectedYear() !== null" type="button" class="year-clear-btn" (click)="clearYear($event)"
          aria-label="Clear year">
          ✕
        </button>
      </div>
    </div>
    <div class="col-auto d-none d-md-block" *ngIf="!isWizardMode">
      <button type="button" class="btn btn-primary mt-md-0 mt-1" [disabled]="selectedProjectIds().size === 0"
        (click)="batchCloneSelected()">
        <span>Batch Clone ({{ selectedProjectIds().size }})</span>
      </button>
    </div>
    <div class="col-auto d-none d-md-block" *ngIf="isNotDefault()">
      <button type="button" class="btn btn-outline-danger mt-md-0 mt-1" (click)="resetTableConfiguration()">
        <fa-icon class="button-icon-left" [icon]="faRotateLeft"></fa-icon>
        <span>Reset</span>
      </button>
    </div>
  </div>
  <div class="batch-table__scroll">
    <div class="batch-table__table-wrap" #tableWrap (scroll)="onTableScroll()">
      <!-- Desktop table -->
      <table *ngIf="!isMobile()" class="table table-hover align-middle batch-table__grid">
        <thead>
          <tr>
            <th class="text-center sticky-col sticky-1" style="width: 44px;">
              <input type="checkbox" class="form-check-input" [checked]="allVisibleSelected()"
                [indeterminate]="someVisibleSelected()" (change)="toggleSelectAllVisible($event.target.checked)"
                aria-label="Select all filtered rows" />
            </th>

            <th class="sticky-col sticky-2" (click)="sort('clientName')"
              style="cursor:pointer; width: var(--col-client);">
              Client
            </th>
            <th class="sticky-col sticky-3" (click)="sort('projectName')"
              style="cursor:pointer; width: var(--col-project);">
              Project
            </th>
            <th class="sticky-col sticky-4" style="width: var(--col-newproject);">
              <span class="d-inline-flex align-items-center gap-2">
                New Project
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popNewProject"
                  #pNewProject="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit New Project">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popNewProject>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set New Project (all filtered)</div>
                  <input class="form-control form-control-sm" [(ngModel)]="bulk().newProjectName" />
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pNewProject.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetText('newProjectName', bulk().newProjectName); pNewProject.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>
            <th class="text-center">
              <span class="d-inline-flex align-items-center justify-content-center gap-2 w-100">
                Send proposal
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen"
                  [ngbPopover]="popAutoSendProposal" #pAutoSendProposal="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click"
                  [autoClose]="'outside'" aria-label="Bulk edit Auto send proposal">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popAutoSendProposal>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Auto send proposal (all filtered)</div>
                  <div class="form-check">
                    <input id="bulkAutoSendProposal" class="form-check-input" type="checkbox"
                      [(ngModel)]="bulk().isAutoSendProposal" />
                    <label class="form-check-label" for="bulkAutoSendProposal">Enabled</label>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pAutoSendProposal.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetBoolean('isAutoSendProposal', bulk().isAutoSendProposal); pAutoSendProposal.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>
            <th *ngIf="projectType != 'expiring'" class="text-center">
              <span class="d-inline-flex align-items-center justify-content-center gap-2 w-100">
                Accept proposal
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popAutoAccept"
                  #pAutoAccept="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit Auto accept proposal">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popAutoAccept>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Auto accept proposal (all filtered)</div>
                  <div class="form-check">
                    <input id="bulkAutoAccept" class="form-check-input" type="checkbox"
                      [(ngModel)]="bulk().isAutoAccept" />
                    <label class="form-check-label" for="bulkAutoAccept">Enabled</label>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pAutoAccept.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetBoolean('isAutoAccept', bulk().isAutoAccept); pAutoAccept.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th *ngIf="projectType === 'expiring'" class="text-center">
              <div class="d-flex align-items-center gap-2">
                <span [ngbTooltip]="'These column sets the available options for the client'">Multi Year</span>

                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popMultiOption"
                  #pMultiOption="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit multi-year options">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </div>

              <ng-template #popMultiOption>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set multi-year options (all filtered)</div>

                  <div class="form-check"
                    *ngFor="let option of getBulkMultiOptionChoices(); let i = index; trackBy: trackByOptionChoice">
                    <input class="form-check-input" type="checkbox" [id]="'bulkMultiOption_' + i"
                      [checked]="isBulkMultiOptionKeySelected(option.key)"
                      (change)="toggleBulkMultiOptionKey(option.key, $any($event.target).checked)" />
                    <label class="form-check-label" [for]="'bulkMultiOption_' + i">
                      {{ option.label }}
                    </label>
                  </div>

                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary"
                      (click)="clearBulkMultiOption(); pMultiOption.close()">
                      Cancel
                    </button>

                    <button class="btn btn-sm btn-primary" [disabled]="(bulk().multiOptionKeys ?? []).length === 0"
                      (click)="bulkSetMultiOption(bulk().multiOptionKeys); pMultiOption.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th *ngIf="projectType === 'expiring'" class="text-center">
              <div class="d-flex align-items-center gap-2">
                <span>Will auto accept?</span>

                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popAutoSelect"
                  #pAutoSelect="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit will auto accept">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </div>

              <ng-template #popAutoSelect>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Will auto accept? (all filtered)</div>

                  <div class="form-check"
                    *ngFor="let option of getBulkMultiOptionChoices(); let i = index; trackBy: trackByOptionChoice">
                    <input class="form-check-input" type="radio" name="bulkAutoSelect" [id]="'bulkAutoSelect_' + i"
                      [checked]="bulk().autoSelect === option.key" (change)="setBulkAutoSelect(option.key)" />
                    <label class="form-check-label" [for]="'bulkAutoSelect_' + i">
                      {{ option.label }}
                    </label>
                  </div>

                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary"
                      (click)="clearBulkAutoSelect(); pAutoSelect.close()">
                      Cancel
                    </button>

                    <button class="btn btn-sm btn-primary" [disabled]="!bulk().autoSelect"
                      (click)="bulkSetAutoSelect(bulk().autoSelect); pAutoSelect.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th>
              <span class="d-inline-flex align-items-center gap-2">
                Send date
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popSendDate"
                  #pSendDate="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit Auto send date">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popSendDate>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Send date & time (all filtered)</div>
                  <ngb-datepicker [minDate]="today" [startDate]="bulk().proposalSendDateAndTime || today"
                    (dateSelect)="setBulkDateValue('proposalSendDateAndTime', $event)">
                  </ngb-datepicker>
                  <div class="input-group input-group-sm">
                    <input type="time" class="form-control form-control-sm" step="900"
                      [(ngModel)]="bulk().proposalSendTime" />
                    <span class="input-group-text"><fa-icon [icon]="faClock"></fa-icon></span>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pSendDate.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetDateTime('proposalSendDateAndTime', bulk().proposalSendDateAndTime, bulk().proposalSendTime); pSendDate.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th class="text-center">
              <span class="d-inline-flex align-items-center justify-content-center gap-2 w-100">
                Create invoice
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen"
                  [ngbPopover]="popCreateInvoice" #pCreateInvoice="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click"
                  [autoClose]="'outside'" aria-label="Bulk edit Create invoice">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popCreateInvoice>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Create invoice (all filtered)</div>
                  <div class="form-check">
                    <input id="bulkCreateInvoice" class="form-check-input" type="checkbox"
                      [(ngModel)]="bulk().isAutoInvoice" />
                    <label class="form-check-label" for="bulkCreateInvoice">Enabled</label>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pCreateInvoice.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetBoolean('isAutoInvoice', bulk().isAutoInvoice); pCreateInvoice.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th>
              <span class="d-inline-flex align-items-center gap-2">
                Invoice type
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popInvType"
                  #pInvType="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit Invoice type">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popInvType>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Invoice type (all filtered)</div>

                  <select class="form-select form-select-sm" [(ngModel)]="bulk().invoiceType">
                    <option value="percentage">Percentage</option>
                    <option value="dollar">Dollar</option>
                  </select>

                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pInvType.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetInvoiceType(bulk().invoiceType); pInvType.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th>
              <span class="d-inline-flex align-items-center gap-2">
                Invoice amount
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popInvAmount"
                  #pInvAmount="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit Invoice amount">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popInvAmount>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Invoice amount (all filtered)</div>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="bulk().invoiceAmount" min="0"
                    step="0.01" />
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pInvAmount.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetNumber('invoiceAmount', bulk().invoiceAmount); pInvAmount.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th>
              <span class="d-inline-flex align-items-center gap-2">
                Issue Date
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popIssueDate"
                  #pIssueDate="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit Issue Date">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popIssueDate>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Issue Date (all filtered)</div>
                  <ngb-datepicker [minDate]="today" [startDate]="bulk().invoiceIssueDate || today"
                    (dateSelect)="setBulkDateValue('invoiceIssueDate', $event)">
                  </ngb-datepicker>
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pIssueDate.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetDate('invoiceIssueDate', bulk().invoiceIssueDate); pIssueDate.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th>
              <span class="d-inline-flex align-items-center gap-2">
                Due Date
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popDueDate"
                  #pDueDate="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit Due Date">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popDueDate>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Due Date (all filtered)</div>
                  <ngb-datepicker [minDate]="today" [startDate]="bulk().invoiceDueDate || today"
                    (dateSelect)="setBulkDateValue('invoiceDueDate', $event)">
                  </ngb-datepicker>
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pDueDate.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetDate('invoiceDueDate', bulk().invoiceDueDate); pDueDate.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th class="text-center">
              <span class="d-inline-flex align-items-center justify-content-center gap-2 w-100">
                Send invoice
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen" [ngbPopover]="popSendInvoice"
                  #pSendInvoice="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click" [autoClose]="'outside'"
                  aria-label="Bulk edit Send invoice">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popSendInvoice>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Send invoice (all filtered)</div>
                  <div class="form-check">
                    <input id="bulkSendInvoice" class="form-check-input" type="checkbox"
                      [(ngModel)]="bulk().isAutoSendInvoice" />
                    <label class="form-check-label" for="bulkSendInvoice">Enabled</label>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pSendInvoice.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetBoolean('isAutoSendInvoice', bulk().isAutoSendInvoice); pSendInvoice.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>

            <th>
              <span class="d-inline-flex align-items-center gap-2">
                Send invoice date
                <button type="button" class="btn btn-link p-0 text-decoration-none th-pen"
                  [ngbPopover]="popSendInvoiceDate" #pSendInvoiceDate="ngbPopover" placement="bottom" [popoverClass]="'full-height-popover'" triggers="click"
                  [autoClose]="'outside'" aria-label="Bulk edit Send invoice date">
                  <fa-icon [icon]="faPen"></fa-icon>
                </button>
              </span>

              <ng-template #popSendInvoiceDate>
                <div class="d-flex flex-column gap-2 w-100 popover-body-100">
                  <div class="fw-semibold">Set Send invoice date & time (all filtered)</div>
                  <ngb-datepicker [minDate]="today" [startDate]="bulk().invoiceSendDate || today"
                    (dateSelect)="setBulkDateValue('invoiceSendDate', $event)">
                  </ngb-datepicker>
                  <div class="input-group input-group-sm">
                    <input type="time" class="form-control form-control-sm" step="900"
                      [(ngModel)]="bulk().invoiceSendTime" />
                    <span class="input-group-text"><fa-icon [icon]="faClock"></fa-icon></span>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-sm btn-outline-secondary" (click)="pSendInvoiceDate.close()">Cancel</button>
                    <button class="btn btn-sm btn-primary"
                      (click)="bulkSetDateTime('invoiceSendDate', bulk().invoiceSendDate, bulk().invoiceSendTime); pSendInvoiceDate.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of viewRows(); trackBy: trackByProjectId">
            <td class="text-center sticky-col sticky-1" data-label="Clone">
              <input type="checkbox" class="form-check-input" [checked]="isRowSelected(row)"
                (change)="toggleRowSelected(row, $event.target.checked)" aria-label="Select row for cloning" />
            </td>

            <td class="sticky-col sticky-2" data-label="Client">{{ row.clientName }}</td>
            <td class="sticky-col sticky-3" data-label="Project">
              <span class="d-block">
                {{ row.projectName }}
              </span>

              @if (projectType === 'expiring' && row.lastAcceptedProposal) {
                <span class="d-block small text-muted mt-1">
                  Previously accepted: {{ row.lastAcceptedProposal }}
                </span>
              }
            </td>

            <td class="sticky-col sticky-4" data-label="New Project">
              <input type="text" class="form-control form-control-sm" [value]="row.newProjectName ?? ''"
                (input)="updateText(row, 'newProjectName', $any($event.target).value)"
                placeholder="Enter new project name" />
            </td>

            <td data-label="Auto send proposal" class="text-center">
              <input type="checkbox" class="form-check-input" [checked]="row.isAutoSendProposal"
                [disabled]="row.isAutoAccept && projectType != 'expiring'"
                (change)="toggleBoolean(row, 'isAutoSendProposal', $event.target.checked)" />
            </td>

            <td *ngIf="projectType != 'expiring'" data-label="Auto accept proposal" class="text-center">
              <input type="checkbox" class="form-check-input" [checked]="row.isAutoAccept"
                (change)="toggleBoolean(row, 'isAutoAccept', $event.target.checked)" />
            </td>

            <td *ngIf="projectType === 'expiring'" class="align-top" data-label="Multi Year">
              <ng-container *ngIf="getEnabledMultiOptionEntries(row).length > 0; else noEnabledOption">
                <label *ngFor="let option of getEnabledMultiOptionEntries(row); trackBy: trackByOptionEntry"
                  class="d-flex align-items-center gap-2 mb-1">
                  <input type="checkbox" [checked]="isRowMultiOptionSelected(row, option[0])"
                    (change)="toggleRowMultiOption(row, option[0], $any($event.target).checked)" />

                  <span>
                    {{ getMultiOptionLabel(option[0], option[1]) }}
                  </span>
                </label>
              </ng-container>

              <ng-template #noEnabledOption>
                <span class="text-muted">No enabled option</span>
              </ng-template>
            </td>

            <td *ngIf="projectType === 'expiring'" data-label="Will auto accept?">
              <select class="form-select form-select-sm" [ngModel]="row.autoSelect ?? ''"
                [disabled]="getSelectedMultiOptionEntries(row).length === 0"
                [class.is-invalid]="isAutoSelectInvalid(row)" (ngModelChange)="setRowAutoSelect(row, $event || null)">
                <option value="">Do not auto accept</option>
                <option *ngFor="let option of getSelectedMultiOptionEntries(row); trackBy: trackByOptionEntry"
                  [ngValue]="option[0]">
                  {{ getMultiOptionLabel(option[0], option[1]) }}
                </option>
              </select>

              <div class="td-error" *ngIf="isAutoSelectInvalid(row)">
                Selected auto accept option must be one of the chosen multi year options.
              </div>
            </td>

            <td data-label="Auto send date">
              <div class="input-group input-group-sm">
                <input class="form-control form-control-sm" readonly [class.is-invalid]="isProposalSendDateInvalid(row)"
                  [value]="formatDateTimeSummary(row.proposalSendDateAndTime)" placeholder="Select date & time" />
                <button type="button" class="btn btn-outline-primary btn-sm" [ngbPopover]="popDtSendDate"
                  #pDtSendDate="ngbPopover" popoverClass="batch-cloning-datetime-popover" placement="bottom"
                  container="body" [autoClose]="'outside'"
                  (hidden)="discardRowDateDraft(row, 'proposalSendDateAndTime')">
                  <fa-icon [icon]="faCalendar"></fa-icon>
                </button>
              </div>
              <ng-template #popDtSendDate>
                <div class="datetime-picker">
                  <ngb-datepicker [minDate]="today"
                    (dateSelect)="setRowDateDraft(row, 'proposalSendDateAndTime', $event)">
                  </ngb-datepicker>
                  <div class="datetime-picker__time">
                    <input type="time" class="form-control form-control-sm" step="900"
                      [value]="toTimeInputValue(getRowDateDraft(row, 'proposalSendDateAndTime')) || '00:00'"
                      (change)="setRowTimeDraft(row, 'proposalSendDateAndTime', $any($event.target).value)" />
                  </div>
                  <div class="datetime-picker__summary" *ngIf="getRowDateDraft(row, 'proposalSendDateAndTime')">
                    <fa-icon [icon]="faCalendar" class="me-1"></fa-icon>
                    <span [textContent]="formatDateTimeSummary(getProposalSendDateDraftValue(row))"></span>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                      [disabled]="!row.proposalSendDateAndTime"
                      (click)="clearRowDate(row, 'proposalSendDateAndTime'); pDtSendDate.close()">
                      Clear
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="pDtSendDate.close()">
                      Cancel
                    </button>
                    <button type="button" class="btn btn-sm btn-primary"
                      [disabled]="!getRowDateDraft(row, 'proposalSendDateAndTime')"
                      (click)="confirmRowDateDraft(row, 'proposalSendDateAndTime'); pDtSendDate.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
              <div class="td-error" *ngIf="isProposalSendDateInvalid(row)">
                Valid send date is required when Send proposal is enabled.
              </div>
            </td>

            <td data-label="Create invoice" class="text-center">
              <span [ngbTooltip]="
                    getCreateInvoiceDisabledTooltip(row)
                  " [disableTooltip]="canCreateInvoice(row)" placement="top" container="body" class="d-inline-block">
                <input type="checkbox" class="form-check-input" [checked]="row.isAutoInvoice"
                  [disabled]="!canCreateInvoice(row)" [attr.title]="getCreateInvoiceDisabledTooltip(row)"
                  (change)="toggleBoolean(row, 'isAutoInvoice', $event.target.checked)" />
              </span>
            </td>

            <td data-label="Invoice type">
              <select class="form-select form-select-sm" [class.is-invalid]="isInvoiceTypeInvalid(row)"
                [ngModel]="row.invoiceType ?? 'percentage'" (ngModelChange)="updateInvoiceType(row, $event)">
                <option value="dollar">Dollar</option>
                <option value="percentage">Percentage</option>
              </select>

              <div class="td-error" *ngIf="isInvoiceTypeInvalid(row)">
                Invoice type must be Percentage or Dollar.
              </div>
            </td>

            <td data-label="Invoice amount">
              <input type="number" class="form-control form-control-sm text-end"
                [class.is-invalid]="isInvoiceAmountInvalid(row)" [value]="row.invoiceAmount ?? ''"
                (input)="updateNumber(row, 'invoiceAmount', $any($event.target).value)" min="0" step="0.01" />
              <div class="td-error" *ngIf="isInvoiceAmountInvalid(row)">
                Invoice amount must be 0 or greater.
              </div>
            </td>

            <td data-label="Issue Date">
              <div class="input-group input-group-sm">
                <input class="form-control form-control-sm" readonly [class.is-invalid]="isInvoiceIssueDateInvalid(row)"
                  [value]="formatDateOnlySummary(row.invoiceIssueDate)" placeholder="Select date" />
                <button type="button" class="btn btn-outline-primary btn-sm" [ngbPopover]="popDtIssueDate"
                  #pDtIssueDate="ngbPopover" popoverClass="batch-cloning-datetime-popover" placement="bottom"
                  container="body" [autoClose]="'outside'" (hidden)="discardRowDateDraft(row, 'invoiceIssueDate')">
                  <fa-icon [icon]="faCalendar"></fa-icon>
                </button>
              </div>
              <ng-template #popDtIssueDate>
                <div class="datetime-picker">
                  <ngb-datepicker [minDate]="today" (dateSelect)="setRowDateDraft(row, 'invoiceIssueDate', $event)">
                  </ngb-datepicker>
                  <div class="datetime-picker__summary" *ngIf="getRowDateDraft(row, 'invoiceIssueDate')">
                    <fa-icon [icon]="faCalendar" class="me-1"></fa-icon>
                    <span [textContent]="formatDateOnlySummary(getInvoiceIssueDateDraftValue(row))"></span>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="!row.invoiceIssueDate"
                      (click)="clearRowDate(row, 'invoiceIssueDate'); pDtIssueDate.close()">
                      Clear
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="pDtIssueDate.close()">
                      Cancel
                    </button>
                    <button type="button" class="btn btn-sm btn-primary"
                      [disabled]="!getRowDateDraft(row, 'invoiceIssueDate')"
                      (click)="confirmRowDateDraft(row, 'invoiceIssueDate'); pDtIssueDate.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
              <div class="td-error" *ngIf="isInvoiceIssueDateInvalid(row)">
                Valid issue date is required.
              </div>
            </td>

            <td data-label="Due Date">
              <div class="input-group input-group-sm">
                <input class="form-control form-control-sm" readonly
                  [class.is-invalid]="isInvoiceDueDateInvalid(row) || isInvoiceDateOrderInvalid(row)"
                  [value]="formatDateOnlySummary(row.invoiceDueDate)" placeholder="Select date" />
                <button type="button" class="btn btn-outline-primary btn-sm" [ngbPopover]="popDtDueDate"
                  #pDtDueDate="ngbPopover" popoverClass="batch-cloning-datetime-popover" placement="bottom"
                  container="body" [autoClose]="'outside'" (hidden)="discardRowDateDraft(row, 'invoiceDueDate')">
                  <fa-icon [icon]="faCalendar"></fa-icon>
                </button>
              </div>
              <ng-template #popDtDueDate>
                <div class="datetime-picker">
                  <ngb-datepicker [minDate]="today" (dateSelect)="setRowDateDraft(row, 'invoiceDueDate', $event)">
                  </ngb-datepicker>
                  <div class="datetime-picker__summary" *ngIf="getRowDateDraft(row, 'invoiceDueDate')">
                    <fa-icon [icon]="faCalendar" class="me-1"></fa-icon>
                    <span [textContent]="formatDateOnlySummary(getInvoiceDueDateDraftValue(row))"></span>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="!row.invoiceDueDate"
                      (click)="clearRowDate(row, 'invoiceDueDate'); pDtDueDate.close()">
                      Clear
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="pDtDueDate.close()">
                      Cancel
                    </button>
                    <button type="button" class="btn btn-sm btn-primary"
                      [disabled]="!getRowDateDraft(row, 'invoiceDueDate')"
                      (click)="confirmRowDateDraft(row, 'invoiceDueDate'); pDtDueDate.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
              <div class="td-error" *ngIf="isInvoiceDueDateInvalid(row)">
                Valid due date is required.
              </div>
              <div class="td-error" *ngIf="!isInvoiceDueDateInvalid(row) && isInvoiceDateOrderInvalid(row)">
                Due date must be on or after issue date.
              </div>
            </td>

            <td data-label="Send invoice" class="text-center">
              <span [ngbTooltip]="!row.isAutoInvoice ? 'Please enable create invoice first' : null"
                [disableTooltip]="row.isAutoInvoice" placement="top" container="body" class="d-inline-block">
                <input type="checkbox" class="form-check-input" [checked]="row.isAutoSendInvoice"
                  [disabled]="!row.isAutoInvoice"
                  [attr.title]="!row.isAutoInvoice ? 'Please enable create invoice first' : null"
                  (change)="toggleBoolean(row, 'isAutoSendInvoice', $event.target.checked)" />
              </span>
            </td>

            <td data-label="Send invoice date">
              <div class="input-group input-group-sm">
                <input class="form-control form-control-sm" readonly
                  [value]="formatDateTimeSummary(row.invoiceSendDate)" placeholder="Select date & time" />
                <button type="button" class="btn btn-outline-primary btn-sm" [ngbPopover]="popDtSendInvDate"
                  #pDtSendInvDate="ngbPopover" popoverClass="batch-cloning-datetime-popover" placement="bottom"
                  container="body" [autoClose]="'outside'" (hidden)="discardRowDateDraft(row, 'invoiceSendDate')">
                  <fa-icon [icon]="faCalendar"></fa-icon>
                </button>
              </div>
              <ng-template #popDtSendInvDate>
                <div class="datetime-picker">
                  <ngb-datepicker [minDate]="today" (dateSelect)="setRowDateDraft(row, 'invoiceSendDate', $event)">
                  </ngb-datepicker>
                  <div class="datetime-picker__time">
                    <input type="time" class="form-control form-control-sm" step="900"
                      [value]="toTimeInputValue(getRowDateDraft(row, 'invoiceSendDate')) || '00:00'"
                      (change)="setRowTimeDraft(row, 'invoiceSendDate', $any($event.target).value)" />
                  </div>
                  <div class="datetime-picker__summary" *ngIf="getRowDateDraft(row, 'invoiceSendDate')">
                    <fa-icon [icon]="faCalendar" class="me-1"></fa-icon>
                    <span [textContent]="formatDateTimeSummary(getInvoiceSendDateDraftValue(row))"></span>
                  </div>
                  <div class="d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="!row.invoiceSendDate"
                      (click)="clearRowDate(row, 'invoiceSendDate'); pDtSendInvDate.close()">
                      Clear
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="pDtSendInvDate.close()">
                      Cancel
                    </button>
                    <button type="button" class="btn btn-sm btn-primary"
                      [disabled]="!getRowDateDraft(row, 'invoiceSendDate')"
                      (click)="confirmRowDateDraft(row, 'invoiceSendDate'); pDtSendInvDate.close()">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </td>
          </tr>

          <tr *ngIf="viewRows().length === 0">
            <td [attr.colspan]="projectType === 'expiring' ? 15 : 14" class="text-muted">No rows</td>
          </tr>
        </tbody>
      </table>

      <!-- Mobile list -->
      <div class="scrollable" *ngIf="isMobile()" (scroll)="closeOpenPopoversOnTableScroll()">
        <ul class="list-group">
          <li *ngFor="let row of viewRows(); trackBy: trackByProjectId" class="list-group-item">
            <div class="d-flex justify-content-between align-items-start">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [checked]="isRowSelected(row)"
                  (change)="toggleRowSelected(row, $event.target.checked)" />
                <label class="form-check-label">Clone</label>
              </div>
            </div>

            <div class="mt-2 d-flex flex-column gap-2">
              <div>
                <label class="form-label mb-1">New Project</label>
                <input type="text" class="form-control form-control-sm" [value]="row.newProjectName ?? ''"
                  (input)="updateText(row, 'newProjectName', $any($event.target).value)" />
              </div>

              <div class="form-check">
                <input class="form-check-input" type="checkbox" [checked]="row.isAutoSendProposal"
                  (change)="toggleBoolean(row, 'isAutoSendProposal', $event.target.checked)" />
                <label class="form-check-label">Send proposal</label>
              </div>

              <div class="form-check" *ngIf="projectType != 'expiring'">
                <input class="form-check-input" type="checkbox" [checked]="row.isAutoAccept"
                  (change)="toggleBoolean(row, 'isAutoAccept', $event.target.checked)" />
                <label class="form-check-label">Accept proposal</label>
              </div>

              <div *ngIf="projectType === 'expiring'">
                <label class="form-label mb-1">Multi Year</label>
                <ng-container *ngIf="getEnabledMultiOptionEntries(row).length > 0; else noMobileEnabledOption">
                  <label *ngFor="let option of getEnabledMultiOptionEntries(row); trackBy: trackByOptionEntry"
                    class="d-flex align-items-center gap-2 mb-1">
                    <input type="checkbox" [checked]="isRowMultiOptionSelected(row, option[0])"
                      (change)="toggleRowMultiOption(row, option[0], $any($event.target).checked)" />
                    <span>{{ getMultiOptionLabel(option[0], option[1]) }}</span>
                  </label>
                </ng-container>

                <ng-template #noMobileEnabledOption>
                  <span class="text-muted">No enabled option</span>
                </ng-template>
              </div>

              <div *ngIf="projectType === 'expiring'">
                <label class="form-label mb-1">Will auto accept?</label>
                <select class="form-select form-select-sm" [ngModel]="row.autoSelect ?? ''"
                  [disabled]="getSelectedMultiOptionEntries(row).length === 0"
                  [class.is-invalid]="isAutoSelectInvalid(row)" (ngModelChange)="setRowAutoSelect(row, $event || null)">
                  <option value="">Do not auto accept</option>
                  <option *ngFor="let option of getSelectedMultiOptionEntries(row); trackBy: trackByOptionEntry"
                    [ngValue]="option[0]">
                    {{ getMultiOptionLabel(option[0], option[1]) }}
                  </option>
                </select>
              </div>

              <div>
                <label class="form-label mb-1">Send date</label>
                <div class="input-group input-group-sm">
                  <input class="form-control form-control-sm" readonly
                    [value]="formatDateTimeSummary(row.proposalSendDateAndTime)" placeholder="Select date & time" />
                  <button type="button" class="btn btn-outline-primary btn-sm" [ngbPopover]="popMobileDtSendDate"
                    #pMobileDtSendDate="ngbPopover" popoverClass="batch-cloning-datetime-popover" placement="bottom"
                    container="body" [autoClose]="'outside'"
                    (hidden)="discardRowDateDraft(row, 'proposalSendDateAndTime')">
                    <fa-icon [icon]="faCalendar"></fa-icon>
                  </button>
                </div>
                <ng-template #popMobileDtSendDate>
                  <div class="datetime-picker">
                    <ngb-datepicker [minDate]="today"
                      (dateSelect)="setRowDateDraft(row, 'proposalSendDateAndTime', $event)">
                    </ngb-datepicker>
                    <div class="datetime-picker__time">
                      <fa-icon [icon]="faClock" class="text-muted"></fa-icon>
                      <input type="time" class="form-control form-control-sm" step="900"
                        [value]="toTimeInputValue(getRowDateDraft(row, 'proposalSendDateAndTime')) || '00:00'"
                        (change)="setRowTimeDraft(row, 'proposalSendDateAndTime', $any($event.target).value)" />
                    </div>
                    <div class="datetime-picker__summary" *ngIf="getRowDateDraft(row, 'proposalSendDateAndTime')">
                      <fa-icon [icon]="faCalendar" class="me-1"></fa-icon>
                      <span [textContent]="formatDateTimeSummary(getProposalSendDateDraftValue(row))"></span>
                    </div>
                    <div class="d-flex justify-content-end gap-2">
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                        [disabled]="!row.proposalSendDateAndTime"
                        (click)="clearRowDate(row, 'proposalSendDateAndTime'); pMobileDtSendDate.close()">
                        Clear
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="pMobileDtSendDate.close()">
                        Cancel
                      </button>
                      <button type="button" class="btn btn-sm btn-primary"
                        [disabled]="!getRowDateDraft(row, 'proposalSendDateAndTime')"
                        (click)="confirmRowDateDraft(row, 'proposalSendDateAndTime'); pMobileDtSendDate.close()">
                        Confirm
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>

              <div class="form-check">
                <span [ngbTooltip]="getCreateInvoiceDisabledTooltip(row)" [disableTooltip]="canCreateInvoice(row)"
                  placement="top" container="body" class="d-inline-block">
                  <input class="form-check-input" type="checkbox" [checked]="row.isAutoInvoice"
                    [disabled]="!canCreateInvoice(row)"
                    (change)="toggleBoolean(row, 'isAutoInvoice', $event.target.checked)" />
                </span>
                <label class="form-check-label">Create invoice</label>
              </div>

              <div>
                <label class="form-label mb-1">Invoice amount</label>
                <input type="number" class="form-control form-control-sm text-end" [value]="row.invoiceAmount ?? ''"
                  (input)="updateNumber(row, 'invoiceAmount', $any($event.target).value)" min="0" step="0.01" />
              </div>

              <div>
                <label class="form-label mb-1">Issue Date</label>
                <div class="input-group input-group-sm">
                  <input class="form-control form-control-sm" readonly
                    [value]="formatDateOnlySummary(row.invoiceIssueDate)" placeholder="Select date" />
                  <button type="button" class="btn btn-outline-primary btn-sm" [ngbPopover]="popMobileDtIssueDate"
                    #pMobileDtIssueDate="ngbPopover" popoverClass="batch-cloning-datetime-popover" placement="bottom"
                    container="body" [autoClose]="'outside'" (hidden)="discardRowDateDraft(row, 'invoiceIssueDate')">
                    <fa-icon [icon]="faCalendar"></fa-icon>
                  </button>
                </div>
                <ng-template #popMobileDtIssueDate>
                  <div class="datetime-picker">
                    <ngb-datepicker [minDate]="today" (dateSelect)="setRowDateDraft(row, 'invoiceIssueDate', $event)">
                    </ngb-datepicker>
                    <div class="datetime-picker__summary" *ngIf="getRowDateDraft(row, 'invoiceIssueDate')">
                      <fa-icon [icon]="faCalendar" class="me-1"></fa-icon>
                      <span [textContent]="formatDateOnlySummary(getInvoiceIssueDateDraftValue(row))"></span>
                    </div>
                    <div class="d-flex justify-content-end gap-2">
                      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="!row.invoiceIssueDate"
                        (click)="clearRowDate(row, 'invoiceIssueDate'); pMobileDtIssueDate.close()">
                        Clear
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="pMobileDtIssueDate.close()">
                        Cancel
                      </button>
                      <button type="button" class="btn btn-sm btn-primary"
                        [disabled]="!getRowDateDraft(row, 'invoiceIssueDate')"
                        (click)="confirmRowDateDraft(row, 'invoiceIssueDate'); pMobileDtIssueDate.close()">
                        Confirm
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>

              <div>
                <label class="form-label mb-1">Due Date</label>
                <div class="input-group input-group-sm">
                  <input class="form-control form-control-sm" readonly
                    [class.is-invalid]="isInvoiceDueDateInvalid(row) || isInvoiceDateOrderInvalid(row)"
                    [value]="formatDateOnlySummary(row.invoiceDueDate)" placeholder="Select date" />
                  <button type="button" class="btn btn-outline-primary btn-sm" [ngbPopover]="popMobileDtDueDate"
                    #pMobileDtDueDate="ngbPopover" popoverClass="batch-cloning-datetime-popover" placement="bottom"
                    container="body" [autoClose]="'outside'" (hidden)="discardRowDateDraft(row, 'invoiceDueDate')">
                    <fa-icon [icon]="faCalendar"></fa-icon>
                  </button>
                </div>
                <ng-template #popMobileDtDueDate>
                  <div class="datetime-picker">
                    <ngb-datepicker [minDate]="today" (dateSelect)="setRowDateDraft(row, 'invoiceDueDate', $event)">
                    </ngb-datepicker>
                    <div class="datetime-picker__summary" *ngIf="getRowDateDraft(row, 'invoiceDueDate')">
                      <fa-icon [icon]="faCalendar" class="me-1"></fa-icon>
                      <span [textContent]="formatDateOnlySummary(getInvoiceDueDateDraftValue(row))"></span>
                    </div>
                    <div class="d-flex justify-content-end gap-2">
                      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="!row.invoiceDueDate"
                        (click)="clearRowDate(row, 'invoiceDueDate'); pMobileDtDueDate.close()">
                        Clear
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="pMobileDtDueDate.close()">
                        Cancel
                      </button>
                      <button type="button" class="btn btn-sm btn-primary"
                        [disabled]="!getRowDateDraft(row, 'invoiceDueDate')"
                        (click)="confirmRowDateDraft(row, 'invoiceDueDate'); pMobileDtDueDate.close()">
                        Confirm
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>

              <div class="form-check">
                <span [ngbTooltip]="!row.isAutoInvoice ? 'Please enable create invoice first' : null"
                  [disableTooltip]="row.isAutoInvoice" placement="top" container="body" class="d-inline-block">
                  <input type="checkbox" class="form-check-input" [checked]="row.isAutoSendInvoice"
                    [disabled]="!row.isAutoInvoice"
                    [attr.title]="!row.isAutoInvoice ? 'Please enable create invoice first' : null"
                    (change)="toggleBoolean(row, 'isAutoSendInvoice', $event.target.checked)" />
                </span>
                <label class="form-check-label">Send invoice</label>
              </div>

              <div>
                <label class="form-label mb-1">Send invoice date</label>
                <div class="input-group input-group-sm">
                  <input class="form-control form-control-sm" readonly
                    [value]="formatDateTimeSummary(row.invoiceSendDate)" placeholder="Select date & time" />
                  <button type="button" class="btn btn-outline-primary btn-sm" [ngbPopover]="popMobileDtSendInvDate"
                    #pMobileDtSendInvDate="ngbPopover" popoverClass="batch-cloning-datetime-popover" placement="bottom"
                    container="body" [autoClose]="'outside'" (hidden)="discardRowDateDraft(row, 'invoiceSendDate')">
                    <fa-icon [icon]="faCalendar"></fa-icon>
                  </button>
                </div>
                <ng-template #popMobileDtSendInvDate>
                  <div class="datetime-picker">
                    <ngb-datepicker [minDate]="today" (dateSelect)="setRowDateDraft(row, 'invoiceSendDate', $event)">
                    </ngb-datepicker>
                    <div class="datetime-picker__time">
                      <input type="time" class="form-control form-control-sm" step="900"
                        [value]="toTimeInputValue(getRowDateDraft(row, 'invoiceSendDate')) || '00:00'"
                        (change)="setRowTimeDraft(row, 'invoiceSendDate', $any($event.target).value)" />
                    </div>
                    <div class="datetime-picker__summary" *ngIf="getRowDateDraft(row, 'invoiceSendDate')">
                      <fa-icon [icon]="faCalendar" class="me-1"></fa-icon>
                      <span [textContent]="formatDateTimeSummary(getInvoiceSendDateDraftValue(row))"></span>
                    </div>
                    <div class="d-flex justify-content-end gap-2">
                      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="!row.invoiceSendDate"
                        (click)="clearRowDate(row, 'invoiceSendDate'); pMobileDtSendInvDate.close()">
                        Clear
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="pMobileDtSendInvDate.close()">
                        Cancel
                      </button>
                      <button type="button" class="btn btn-sm btn-primary"
                        [disabled]="!getRowDateDraft(row, 'invoiceSendDate')"
                        (click)="confirmRowDateDraft(row, 'invoiceSendDate'); pMobileDtSendInvDate.close()">
                        Confirm
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </li>

          <li *ngIf="viewRows().length === 0" class="list-group-item">No rows</li>
        </ul>
      </div>
    </div>

    <!-- STICKY HORIZONTAL SCROLLBAR (ALWAYS VISIBLE) -->
    <div class="batch-table__xbar" #xBar (scroll)="onXBarScroll()" aria-hidden="true">
      <div class="batch-table__xbar-inner" [style.width.px]="xBarWidth()"></div>
    </div>

    <!-- footer (no scroll) -->
    <div class="row table-controls batch-table__footer">
      <div class="col">
        <div ngbDropdown placement="top-left" class="d-inline-block">
          <button class="btn btn-outline-primary" ngbDropdownToggle>
            <span *ngIf="!isMobile()">Page Size: </span> {{ limit() }}
          </button>

          <div ngbDropdownMenu class="page-size-dropdown" *ngIf="!isMobile()">
            <button ngbDropdownItem (click)="setLimit(20)">20</button>
            <button ngbDropdownItem (click)="setLimit(50)">50</button>
            <button ngbDropdownItem (click)="setLimit(100)">100</button>
          </div>

          <div ngbDropdownMenu class="page-size-dropdown" *ngIf="isMobile()">
            <button ngbDropdownItem (click)="setLimit(5)">5</button>
            <button ngbDropdownItem (click)="setLimit(10)">10</button>
            <button ngbDropdownItem (click)="setLimit(20)">20</button>
          </div>
        </div>
      </div>

      <div class="col">
        <ngb-pagination class="d-flex justify-content-end" *ngIf="totalCount() > 0" [page]="page()" [pageSize]="limit()"
          [collectionSize]="totalCount()" [boundaryLinks]="true" [maxSize]="(isMobile() ? 1 : 10)" [ellipses]="true"
          [rotate]="true" (pageChange)="setCurrentPage($event)"></ngb-pagination>
      </div>
    </div>
  </div>
</div>